import {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import {IFooterContactsData} from "@housebets/housebets-x-package/lib/components/feature/footer/FooterContacts/types";
import {SocialsIcon} from "@housebets/housebets-x-package/lib/components/icons";
import {useAppSelector} from "hooks/useAppSelector";
import {useLangNavigate} from "app/hooks/useLangNavigate";

export const useFooterData = () => {
    const {$t} = useIntl();
    const socialMediaList = useAppSelector((state) => state.config.platformConfig?.socialMediaList) || [];
    const [isReadMoreModalOpen, setIsReadMoreModalOpen] = useState(false);
    const langNavigate = useLangNavigate();

    const casinoLinks = {
        title: $t({id: "Casino"}),
        items: [
            {
                href: langNavigate("/casino?type=all"),
                title: $t({id: "CasinoHome"}),
            },
            {
                href: langNavigate("/casino?type=slots"),
                title: $t({id: "Slots"}),
            },
            {
                href: langNavigate("/casino?type=live"),
                title: $t({id: "LiveCasino"}),
            },
            {
                href: langNavigate("/casino?type=new-releases"),
                title: $t({id: "NewReleases"}),
            },
            {
                href: langNavigate("/"),
                title: $t({id: "Recommended"}),
            },
            {
                href: langNavigate("/casino?type=table-game"),
                title: $t({id: "TableGame"}),
            },
            {
                href: langNavigate("/casino?type=blackjack"),
                title: $t({id: "BlackJack"}),
            },
            {
                href: langNavigate("/casino?type=roulette"),
                title: $t({id: "Roulette"}),
            },
            {
                href: langNavigate("/casino?type=baccarat"),
                title: $t({id: "Baccarat"}),
            },
        ],
    };
    const sportsLinks = {
        title: $t({id: "Sports"}),
        items: [
            {
                href: langNavigate("/sports"),
                title: $t({id: "SportsHome"}),
            },
        ],
    };
    const promoLinks = {
        title: $t({id: "Promo"}),
        items: [
            {
                href: langNavigate("/vip"),
                title: $t({id: "Rewards"}),
            },
            {
                href: langNavigate("/"),
                title: $t({id: "Promotions"}),
            },
        ],
    };

    const supportLinks = {
        title: $t({id: "SupportLegal"}),
        items: [
            {
                href: langNavigate("/help/TermsOfService"),
                title: $t({id: "TermsOfService"}),
            },
            {
                href: langNavigate("/help/ResponsibleGambling"),
                title: $t({id: "ResponsibleGambling"}),
            },
            {
                href: langNavigate("/help/SelfExclusion"),
                title: $t({id: "SelfExclusion"}),
            },
            {
                href: langNavigate("/help/DisputeResolution"),
                title: $t({id: "DisputeResolution"}),
            },
            {
                href: langNavigate("/help/AML"),
                title: $t({id: "AntiMoneyLaundering"}),
            },
            {
                href: langNavigate("/help/FairnessAndRNGTestingMethods"),
                title: $t({id: "FairnessAndRNGTestingMethods"}),
            },
            {
                href: langNavigate("/help/KYCPolicy"),
                title: $t({id: "KYCPolicies"}),
            },
            {
                href: langNavigate("/help/PrivacyPolicy"),
                title: $t({id: "PrivacyPolicy"}),
            },
            {
                href: langNavigate("/help/AccountsPayoutsBonuses"),
                title: $t({id: "AccountsPayoutsBonuses"}),
            },
            {
                href: langNavigate("/help/FAQ"),
                title: $t({id: "FAQ"}),
            },
            {
                href: langNavigate("/help/TermsAndConditions"),
                title: $t({id: "TermsAndConditions"}),
            },
        ],
    };
    const [contactUsInfo, setContactUsInfo] = useState<IFooterContactsData>({
        title: $t({id: "ContactUs"}),
        mail: "support@housebets.com",
        readMore: {
            link: "",
            onClick: () => {
                setIsReadMoreModalOpen((prev) => !prev);
            },
            text: $t({id: "ReadMore"}),
        },
        socials: {
            title: $t({id: "OurCommunity"}),
            list: [
                {
                    href: socialMediaList.find((v) => v.name === "TG")?.linkUrl || "/",
                    icon: <SocialsIcon type="telegram" />,
                },
                {
                    href: socialMediaList.find((v) => v.name === "DC")?.linkUrl || "/",
                    icon: <SocialsIcon type="discord" />,
                },
                {
                    href: socialMediaList.find((v) => v.name === "TW")?.linkUrl || "/",
                    icon: <SocialsIcon type="x" />,
                },
            ],
        },
        text: $t({id: "WebDesc"}),
    });

    useEffect(() => {
        setContactUsInfo((prev) => ({
            ...prev,
            readMore: {
                link: "",
                onClick: () => {
                    setIsReadMoreModalOpen((prev) => !prev);
                },
                text: $t({ id: 'ReadMore' }),
            },
            socials: {
                ...prev.socials,
                list: [
                    {
                        href: socialMediaList.find((v) => v.name === "TG")?.linkUrl || "/",
                        icon: <SocialsIcon type="telegram" />,
                    },
                    {
                        href: socialMediaList.find((v) => v.name === "DC")?.linkUrl || "/",
                        icon: <SocialsIcon type="discord" />,
                    },
                    {
                        href: socialMediaList.find((v) => v.name === "TW")?.linkUrl || "/",
                        icon: <SocialsIcon type="x" />,
                    },
                ],
            },
            text: $t({id: "WebDesc"}),
        }));
    }, [socialMediaList, $t]);

    return {
        casinoLinks,
        sportsLinks,
        promoLinks,
        supportLinks,
        contactUsInfo,
        isReadMoreModalOpen,
        setIsReadMoreModalOpen,
    };
};
